export enum Feature {
  // General
  HideContactBusinessPartnerInDialog = 'HideContactBusinessPartnerInDialog',
  ForceCenterTextInOtpErrorDialog = 'ForceCenterTextInOtpErrorDialog',
  CallCheckPasswordMigrateApi = 'CallCheckPasswordMigrateApi', // whether to call check_password_migrate api
  LoginHideSignupButton = 'LoginHideSignupButton', // Hiding the signup button in login page, but not the signup route.
  LoginTermsOfService = 'LoginTermsOfService',
  HomepageRedirection = 'HomepageRedirection',
  ShowPoweredByShopeeText = 'ShowPoweredByShopeeText',
  EnableLoginTimeout = 'EnableLoginTimeout',
  ValidateAuthenticationRedirectionConfig = 'ValidateAuthenticationRedirectionConfig', // Validate Next URL on entry
  SupportZaloOtp = 'SupportZaloOtp',
  SupportViberOtp = 'SupportViberOtp',
  SendVerifyOtpResponseTracking = 'SendVerifyOtpResponseTracking',
  WebTracking = 'WebTracking',
  AppTracking = 'AppTracking',
  LanguageSelector = 'LanguageSelector',
  AccountSuspendedUseHelpCenterLink = 'AccountSuspendedUseHelpCenterLink',
  HideShopeeLogo = 'HideShopeeLogo', // hide shopee logo. Currently used in one credential flows

  // Login by password
  LoginByPasswordEntrance = 'LoginByPasswordEntrance',
  LoginByPasswordAllowEmail = 'LoginByPasswordAllowEmail', // allow login using email + password
  LoginByPasswordAllowPhone = 'LoginByPasswordAllowPhone', // allow login using phone + password
  LoginByPasswordRestrictPasswordLength = 'LoginByPasswordRestrictPasswordLength', // Restrict password length in password input.
  LoginByPasswordNewUserHint = 'LoginByPasswordNewUserHint', // hint to new user to log in with phone instead
  LoginByPasswordCheckPasswordExistApi = 'LoginByPasswordCheckPasswordExistApi', // Check password exist for an account
  LoginByPasswordShowResetPasswordLinkInSmallDevice = 'LoginByPasswordShowResetPasswordLinkInSmallDevice', // if true, the link to reset password is beside the password input. if false, the link to reset password is below the password input
  LoginByPasswordSetNewPasswordOnInitialLogin = 'LoginByPasswordSetNewPasswordOnInitialLogin',
  LoginByPasswordSkipShopeeAccountConfirmation = 'LoginByPasswordSkipShopeeAccountConfirmation', // if false, will show use Shopee Account confirmation page
  LoginByPasswordLayoutRefactor = 'LoginByPasswordLayoutRefactor',
  LoginByPasswordOneCredentialLayoutRefactor = 'LoginByPasswordOneCredentialLayoutRefactor',
  LoginByPasswordShowLoginTip = 'LoginByPasswordShowLoginTip', // master toggle for login tip

  // Login by OTP
  LoginByOtpEntrance = 'LoginByOtpEntrance',
  LoginByOtpAllowEmail = 'LoginByOtpAllowEmail',
  LoginByOtpAllowPhone = 'LoginByOtpAllowPhone',
  LoginByOtpNotRegisteredRedirectToSignup = 'LoginByOtpNotRegisteredRedirectToSignup', // For businesses with phone OTP login, if the account has not been registered, proceed to Signup Page.
  LoginByOtpSupportWAL = 'LoginByOtpSupportWAL',

  // Login by Biometric
  // support biometrics login
  BiometricsV1 = 'BiometricsV1',
  // support biometrics login + passcode login, ToB Account SDK has breaking changes comparing with v1
  // v2 toggle is not only related feature greyscale, it means what version of ToB Account SDK is used
  // if business app doesn't require passcode feature but it integrates with latest ToB Account SDK, we should also enable this toggle
  // for feature greyscale, we should use CCMS feature toggle instead
  BiometricsV2 = 'BiometricsV2',
  LoginByBiometricsSupportWAL = 'LoginByBiometricsSupportWAL',
  LoginByBiometricsEmailOtp = 'LoginByBiometricsEmailOtp',

  // Quick Login
  QuickLogin = 'QuickLogin',

  // Signup by OTP
  SignupByOtpEntrance = 'SignupByOtpEntrance',
  SignupByOtpEnableOneCredential = 'SignupByOtpEnableOneCredential',
  SignupByOtpAllowEmail = 'SignupByOtpAllowEmail',
  SignupByOtpAllowPhone = 'SignupByOtpAllowPhone',
  SignupByOtpRequireAcceptTermsAndService = 'SignupByOtpRequireAcceptTermsAndService',
  SignupByOtpRequirePassword = 'SignupByOtpRequirePassword',
  SignupByOtpCustomiseResendOtpMessage = 'SignupByOtpCustomiseResendOtpMessage',
  SignupByOtpLoginUponAlreadyRegisteredWithPhone = 'SignupByOtpLoginUponAlreadyRegisteredWithPhone', // For businesses with phone OTP login, we can directly login users if they are already registered
  SignupByOtpLoginUponAlreadyRegisteredWithEmail = 'SignupByOtpLoginUponAlreadyRegisteredWithEmail', // For businesses with email OTP login, we can directly login users if they are already registered
  SignupByOtpHideSignupTip = 'SignupByOtpHideSignupTip',
  SignupByOtpSkipAlreadyRegistered = 'SignupByOtpSkipAlreadyRegistered',
  SignupByOtpSkipSignupSuccess = 'SignupByOtpSkipSignupSuccess',
  SignupByOtpDisableReclaimPhone = 'SignupByOtpDisableReclaimPhone', // Disable phone reclaim in signup by otp
  SignupByOtpSupportWAL = 'SignupByOtpSupportWAL',
  SignupByOtpLayoutRefactor = 'SignupByOtpLayoutRefactor',

  // Reset password
  ResetPasswordEntrance = 'ResetPassword',
  ResetPasswordShowHelpText = 'ResetPasswordShowHelpText',
  ResetPasswordByPhone = 'ResetPasswordByPhone',
  ResetPasswordByEmail = 'ResetPasswordByEmail',
  ResetPasswordCallResetPasswordInit = 'ResetPasswordCallResetPasswordInit', // if true, will check with server if the account exists and if it is one credential account
  ResetPasswordSuccessCountdownPage = 'ResetPasswordSuccessCountdownPage',
  ResetPasswordHandledByBusinessPartner = 'ResetPasswordHandledByBusinessPartner', // show a popup instead of navigating to reset password route, informing that reset password is handled by business partner
  ResetPasswordOnShopeeJumpToToC = 'ResetPasswordOnShopeeJumpToToC',

  // Shopeepay specific
  ShopeePayLoginByPassword = 'ShopeePayLoginByPassword', // allow route handling for ShopeePay login (/login)
  ShopeePayChangePassword = 'ShopeePayChangePassword', // allow route handling for ShopeePay change password (/changePass)
  LoginByPasswordRedirectToShopeePay = 'LoginByPasswordRedirectToShopeePay', // for legacy shopeepay app that goes to `shopee-partner.business.accounts.shopee.<cid>/login`, auto redirect them to `pay.business.accounts.shopee.<cid>/login` domain
  ShopeePayMigrationBanner = 'ShopeePayMigrationBanner',

  // Shopee Partner specific
  ShopeePartnerWeb = 'ShopeePartnerWeb',
  ShopeePartnerDesktopBackground = 'ShopeePartnerDesktopBackground',
  ShopeePartnerHashPassword = 'ShopeePartnerHashPassword', // For TH/VN in shopee partner, password field is not hashed, as in the past it supported ShopeePay. Long term goal is to hash the password field for whole of shopee partner remove this toggle

  // WebView
  WebViewNotifyLoginError = 'WebViewNotifyLoginError',
  WebViewLogoutAfterCredentialChange = 'WebViewLogoutAfterCredentialChange', // Notify webview to log out after credential change in flows like add/change email, phone or password
  OpenAccountDeleteLinkAsExternalUrl = 'OpenAccountDeleteLinkAsExternalUrl', // Open link as external URL
  OpenAccountDeleteIosLinkAsAppRL = 'OpenAccountDeleteIosLinkAsAppRL', // Open link as appRL https://confluence.shopee.io/display/SPAT/Navigate+AppRL
  OpenAccountDeleteAndroidLinkAsAppRL = 'OpenAccountDeleteAndroidLinkAsAppRL', // Open link as appRL https://confluence.shopee.io/display/SPAT/Navigate+AppRL
  NotifyRefreshToken = 'NotifyRefreshToken', // Returning nonce after changing credentials, , e.g change password
  // If both toggles are not true, will not call either method
  // NOTE: This is for older app versions. If this is true, will send using older and unsafe method of notifyDidFinishToBLogin
  // NOTE: THIS TOGGLE SHOULD NEVER BE TRUE BY DEFAULT. If business starts supporting, they should use the new method of notifyRefreshToBToken.
  // At most, this toggle should be enabled up to a specified version.
  NotifyRefreshTokenLegacy = 'NotifyRefreshTokenLegacy',
  OpenSignupTipFormAsExternalUrl = 'OpenSignupTipFormAsExternalUrl', // Open SignupByOtpTip form link as external url
  WebViewLoginSuccessfullySendFromSource = 'WebViewLoginSuccessfullySendFromSource', // whether the webViewLoginSuccessfully() command should send the fromSource parameter
  WebViewNotifySignupSuccess = 'WebViewNotifySignupSuccess', // whether the webViewNotifySignupSuccess() command should be called
  // Account pages
  UserAccountEntrance = 'UserAccountEntrance', // user account settings page
  UserManagePhoneNumber = 'UserManagePhoneNumber',
  UserManageEmail = 'UserManageEmail',
  UserManageUsername = 'UserManageUsername',
  UserManagePassword = 'UserManagePassword',
  UserManageToCPassword = 'UserManageToCPassword',
  UserShowToCPhoneInfo = 'UserShowToCPhoneInfo',
  UserShowToCHelpFooter = 'UserShowToCHelpFooter',
  UserManageToCLinkedEmail = 'UserManageToCLinkedEmail',
  AdminManagePhoneNumber = 'AdminManagePhoneNumber',
  AdminManageEmail = 'AdminManageEmail',
  AdminManageUsername = 'AdminManageUsername',
  AdminManagePassword = 'AdminManagePassword',
  AccountDeleteEntranceIOS = 'AccountDeleteEntranceIOS', // delete account entrance on account settings page (IOS only)
  AccountDeleteEntranceAndroid = 'AccountDeleteEntranceAndroid', // delete account entrance on account settings page (Android only)
  UnmaskUserPhone = 'UnmaskUserPhone',
  UnmaskUserEmail = 'UnmaskUserEmail',
  UserCredentialsCommit = 'UserCredentialsCommit',

  // User phone
  UserPhoneEntrance = 'UserPhoneEntrance', // user phone settings (add/change)
  UserAddPhone = 'UserAddPhone',
  UserChangePhone = 'UserChangePhone',
  UserChangePhoneSupportWAL = 'UserChangePhoneSupportWAL',
  CallChangePhoneInitApiInProfilePage = 'CallChangePhoneInitApiInProfilePage', // whether to call change_phone_init api
  ChangePhoneUseNativeVerification = 'ChangePhoneUseNativeVerification', // redirect to native verification page before change phone flow

  // User email
  UserEmailEntrance = 'UserEmailEntrance', // user email settings (add/change)
  UserAddEmail = 'UserAddEmail',
  UserChangeEmail = 'UserChangeEmail',
  CallChangeEmailInitApiInProfilePage = 'CallChangeEmailInitApiInProfilePage', // whether to call change_email_init api
  ChangeEmailUseNativeVerification = 'ChangeEmailUseNativeVerification', // redirect to native verification page before change email flow

  // User password
  UserPasswordEntrance = 'UserPasswordEntrance', // user password settings (add/change)
  UserPasswordForgetPrompt = 'UserPasswordForgetPrompt',
  UserPasswordWebLogoutAfterCredentialChange = 'UserPasswordWebLogoutAfterCredentialChange',
  CallChangePasswordInitApiInProfilePage = 'CallChangePasswordInitApiInProfilePage', // whether to call change_password_init api
  ChangePasswordUseNativeVerification = 'ChangePasswordUseNativeVerification', // redirect to native verification page before change password flow

  // User account linkage
  UserAccountLinkage = 'UserAccountLinkage',

  // OTP SS
  VerifyOtpSharedService = 'VerifyOtpSharedService',

  // One Credential
  OneCredential = 'OneCredential',
  OneCredentialAllowPhone = 'OneCredentialAllowPhone', // Toggle to determine whether account migration will allow phone in account binding/migration
  OneCredentialAllowEmail = 'OneCredentialAllowEmail', // Toggle to determine whether account migration will allow email in account binding/migration
  OneCredentialSupportToBAccount = 'OneCredentialSupportToBAccount', // Will be false only pure ToC businesses.
  OneCredentialLoginOneToOneFlow = 'OneCredentialLoginOneToOneFlow', // Should be true for businesses with 1:1 ToB to ToC linking, except for SPX (for legacy reasons)
  OneCredentialAcceptInvitation = 'OneCredentialAcceptInvitation',
  OneCredentialLoginShowNoLinkedToBAccountError = 'OneCredentialLoginShowNoLinkedToBAccountError',
  OneCredentialSignupSkipCreateAccountPage = 'OneCredentialSignupSkipCreateAccountPage', // If true, skips the CreateAccount page in one credential account bind flow
  OneCredentialOptional = 'OneCredentialOptional', // Toggle to determine whether to enable one credential delink flow

  // One Credential Migration
  OneCredentialMigrationEntrance = 'OneCredentialMigrationEntrance',
  OneCredentialMigrationAllowStaffToChangePhoneAndEmail = 'OneCredentialMigrationAllowStaffToChangePhoneAndEmail',
  OneCredentialMigrationDisallowNotifyAdmin = 'OneCredentialMigrationDisallowNotifyAdmin',
  OneCredentialMigrationCallCheckAuthKeyAvailable = 'OneCredentialMigrationCallCheckAuthKeyAvailable',
  OneCredentialMigrationBypassOtp = 'OneCredentialMigrationBypassOtp',
  OneCredentialMigrationNotifyMigrationSuccess = 'OneCredentialMigrationNotifyMigrationSuccess',
  OneCredentialMigrationLinkingNoticePopup = 'OneCredentialMigrationLinkingNoticePopup',
  OneCredentialShouldCreateToBAccount = 'OneCredentialShouldCreateToBAccount',
  OneCredentialMigrationSkipAccountUpdate = 'OneCredentialMigrationSkipAccountUpdate',
  OneCredentialMigrationSupportWAL = 'OneCredentialMigrationSupportWAL',

  // OneCredentialDelink
  OneCredentialDelinkEntrance = 'OneCredentialDelinkEntrance',
  OneCredentialDelinkAllowPhone = 'OneCredentialDelinkAllowPhone',
  OneCredentialDelinkAllowEmail = 'OneCredentialDelinkAllowEmail',
  OneCredentialDelinkSetPasswordEnabled = 'OneCredentialDelinkSetPasswordEnabled',
  OneCredentialDelinkSupportWAL = 'OneCredentialDelinkSupportWAL',
  OneCredentialDelinkAllowUsername = 'OneCredentialDelinkAllowUsername',

  // One Credential Switch ToC Link
  OneCredentialSwitchToCLinkAdminEnabled = 'OneCredentialSwitchToCLinkAdminEnabled',
  OneCredentialSwitchToCLinkStaffEnabled = 'OneCredentialSwitchToCLinkStaffEnabled',

  // Thirdparty Integration
  ThirdpartyIntegrationSupportShopeeInApp = 'ThirdpartyIntegrationSupportShopeeInApp',
  ThirdpartyIntegrationSupportShopeeInWeb = 'ThirdpartyIntegrationSupportShopeeInWeb',

  // IVS
  IvsIntegration = 'IvsIntegration',
  VerifyPasswordSharedService = 'VerifyPasswordSharedService',
  IvsSharedService = 'IvsSharedService',

  // Temporary toggles
  /**
   * For each business line, these toggles should be MUTUALLY EXCLUSIVE per region (only 1 toggle can take effect per region)
   */
  SPXRebrandUI = 'SPXRebrandUI', // Temporary toggle for SPX Rebranding
  SPXDebrandUI = 'SPXDebrandUI',
  SPXOrangeBackgroundUI = 'SPXOrangeBackgroundUI',
  SendLanguageInSendOtp = 'SendLanguageInSendOtp', // Temporary toggle for sending language parameter to the send_otp API

  // Tob One Credential
  TobOneCredential = 'TobOneCredential',
}

export enum RuleType {
  GreyscaleDeviceFingerprint = 2,
}
